// extracted by mini-css-extract-plugin
export default {"application-page":"ApplicationPage_application-page__bMI2f","application-title":"ApplicationPage_application-title__Va8m+"};